// extracted by mini-css-extract-plugin
export default {"btnBox":"ButtonPrimary_btnBox__wBQSY"};